// App.tsx registra a mesma tela em rotas-alias (ex.: `/pos` e `/backoffice/pos`).
// Sem normalizar, o mesmo protótipo acumularia comentários diferentes conforme
// a URL de entrada. Chaveamos os comentários pela rota canônica (a versão com
// prefixo de portal, que é sempre registrada e navegável).
const ALIAS_TO_CANONICAL: Record<string, string> = {
  '/pos': '/backoffice/pos',
  '/terminals': '/portal-payfacs/terminals',
  '/pendencias': '/portal-payfacs/pendencias',
  '/plano-taxas': '/portal-payfacs/plano-taxas',
  '/solicitar-maquininhas': '/portal-payfacs/solicitar-maquininhas',
  '/transacoes': '/portal-payfacs/transacoes',
  '/busca-chat': '/portal-payfacs/busca-chat',
  '/dashboard-saldos': '/portal-sellers/dashboard-saldos',
  '/dashboard-saldos-v2': '/portal-sellers/dashboard-saldos-v2',
  '/dashboard-saldos-v3-1': '/portal-sellers/dashboard-saldos-v3-1',
  '/dashboard-saldos-v4': '/portal-sellers/dashboard-saldos-v4',
};

export function canonicalRoute(pathname: string): string {
  const clean = pathname.replace(/\/+$/, '') || '/';
  return ALIAS_TO_CANONICAL[clean] || clean;
}
